<template>
    <div id="warnDetail">
        <el-dialog title="详细记录" :visible.sync="dialogWarnDetail.show" width="660px" :modal-append-to-body='false'>
            <div class="table">
                <el-table :data="warnArr" style="width: 100%;"  stripe>
                    <el-table-column  label="参数">
                        {{monitorParameter}}
                    </el-table-column>
                    <el-table-column prop="alarmType" label="类型" :formatter="typeformatter"></el-table-column>
                    <el-table-column prop="dataTime" label="警报时间" ></el-table-column>
                    <el-table-column prop="dataJson" label="值" ></el-table-column>
                    <!-- <el-table-column prop="ad_rate" label="警报率" width="80" :formatter="adRateformatter"></el-table-column> -->
                    <el-table-column prop="overRate" label="超出率"  :formatter="overRateformatter"></el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                    @current-change="CurrentChange"
                    :current-page="this.pageSecond"
                    :page-size="10" layout="total,prev, pager, next, jumper"
                    :total="this.totalSecond" class="pagination" background >
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: 'WarnDetail',
        props:{
            dialogWarnDetail:Object,
            totalSecond:'',
            pageSecond:'',
            measureNo:'',
            monitorParameter: '',
            sdate:'',
            edate:'',
            type:'',
            row:'',
            warnArr:{
                Type:Array,
                default: () => []
            },
        },
        data () {
            return {
                backType:'',
            }
        },
        mounted:function(){

        },
        methods:{
            adRateformatter(row,column){
                const adRate = row[column.property];
                if(adRate == 0){
                    return '0.0'
                }else{
                    return adRate
                }
            },
            overRateformatter(row,column){
                const overRate = row[column.property];
                return `${overRate*100}%`;
            },
            typeformatter(row,column){
                const adType = row[column.property];
                if(adType == 1 || adType == 3 || adType == 5 || adType == 7){
                    this.backType=1
                    return '预警'
                }else if(adType == 2 || adType == 4 || adType == 6 || adType == 8){
                    this.backType=2
                    return '报警'
                }
            },
            CurrentChange(val) {
                // console.log(val,11111)
                this.$emit('changeEvent',val,this.row,this.backType)
                // this.page = val;
                // const req = {
                //     measureNo: this.measureNo,
                //     sdate: this.sdate,
                //     edate: this.edate,
                //     warn: this.type,
                //     page: this.page,
                // }
                // this.$axios.get('/api/monitor/dataHistory/getWarnDetail',req).then(res => {
                //    // this.totalSecond = res.data.data.page.total;
                //    // this.$emit('update:warnArr', res.data.data.page.content)
                // });

            },
        }
    }
</script>

<style>
  #warnDetail .el-dialog__header {
    text-align: center;
    padding: 20px 30px 10px;
    /*background-image: url('../../assets/img/modal_bg.png')*/
    background: linear-gradient(
      -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%);
    border-radius: 2.5px 2.5px 0px 0px;
    transition: unset;
  }
  #warnDetail .el-dialog__body {
    padding: 10px 20px;
  }

  #warnDetail .el-dialog__title {
    text-align: center;
    font-size: 18px;
    color: #fff;
  }
    /*.el-dialog__header {*/
    /*    padding: 20px 30px 10px;*/
    /*}*/

    /*.el-dialog__body {*/
    /*    padding: 10px 20px;*/
    /*}*/

</style>

<style scoped>

    .pagination{
        margin-top: 30px;
        margin-bottom: 20px;
        text-align: center;
    }

</style>



// WEBPACK FOOTER //
// src/components/dataManage/WarnDetail.vue